import { get, set, keys, del } from "idb-keyval";

const KEY_PREFIX = "e2ee:pt:";
const MAX_STORED_MESSAGES = 10_000;

async function contentHash(content: string): Promise<string> {
  const bytes = new TextEncoder().encode(content);
  const hashBuffer = await crypto.subtle.digest("SHA-256", bytes);
  const hashArray = new Uint8Array(hashBuffer);
  let hex = "";
  for (let i = 0; i < hashArray.length; i++) {
    hex += hashArray[i].toString(16).padStart(2, "0");
  }
  return hex;
}

function idbKey(hash: string): string {
  return `${KEY_PREFIX}${hash}`;
}

export async function storePlaintext(
  encryptedContent: string,
  plaintext: string,
): Promise<void> {
  const hash = await contentHash(encryptedContent);
  await set(idbKey(hash), { pt: plaintext, ts: Date.now() });
}

export async function getPlaintext(
  encryptedContent: string,
): Promise<string | undefined> {
  const hash = await contentHash(encryptedContent);
  const entry = await get<{ pt: string; ts: number }>(idbKey(hash));
  return entry?.pt;
}

export async function pruneOldMessages(): Promise<void> {
  const allKeys = await keys();
  const ptKeys = allKeys.filter(
    (k) => typeof k === "string" && k.startsWith(KEY_PREFIX),
  ) as string[];

  if (ptKeys.length <= MAX_STORED_MESSAGES) return;

  const entries: { key: string; ts: number }[] = [];
  for (const key of ptKeys) {
    const entry = await get<{ pt: string; ts: number }>(key);
    entries.push({ key, ts: entry?.ts ?? 0 });
  }

  entries.sort((a, b) => a.ts - b.ts);
  const toDelete = entries.slice(0, entries.length - MAX_STORED_MESSAGES);
  for (const entry of toDelete) {
    await del(entry.key);
  }
}
